import { render, staticRenderFns } from "./GlassJigouInformation.vue?vue&type=template&id=105e0773&scoped=true&"
import script from "./GlassJigouInformation.vue?vue&type=script&lang=js&"
export * from "./GlassJigouInformation.vue?vue&type=script&lang=js&"
import style0 from "./GlassJigouInformation.vue?vue&type=style&index=0&id=105e0773&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105e0773",
  null
  
)

export default component.exports